'use client';
import { Workflow, Activity, ArrowRight } from 'lucide-react';
import { useT } from '../../i18n';

const ProductCardsSection = () => {
  const t = useT();

  const products = [
    {
      id: 'landlink',
      title: t('products.landlink.title'),
      subtitle: t('products.landlink.subtitle'),
      description: t('products.landlink.desc'),
      features: [
        t('products.landlink.f1'),
        t('products.landlink.f2'),
        t('products.landlink.f3'),
        t('products.landlink.f4'),
      ],
      icon: <Workflow className="w-8 h-8" />,
      href: '/landlink',
    },
    {
      id: 'bizpulse',
      title: t('products.bizpulse.title'),
      subtitle: t('products.bizpulse.subtitle'),
      description: t('products.bizpulse.desc'),
      features: [
        t('products.bizpulse.f1'),
        t('products.bizpulse.f2'),
        t('products.bizpulse.f3'),
        t('products.bizpulse.f4'),
      ],
      icon: <Activity className="w-8 h-8" />,
      href: '/bizpulse',
    },
  ];

  return (
    <section id="products" className="py-12 lg:py-16 relative bg-jkd-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8">
          <span className="inline-block px-4 py-2 bg-jkd-gray-100 text-jkd-gold text-sm font-mono tracking-widest mb-4 rounded">
            {t('products.tag')}
          </span>
          <h2 className="section-title text-white">
            <span className="text-gradient-gold">{t('products.title')}</span>
          </h2>
          <p className="section-subtitle mx-auto mt-4">
            {t('products.subtitle')}
          </p>
          <div className="divider-gold mx-auto mt-6" />
        </div>

        {/* Product Cards */}
        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {products.map((product) => (
            <a
              key={product.id}
              href={product.href}
              className="group relative block card-dark card-gold-border glow-gold hover:-translate-y-1 transition-all duration-300"
            >
              {/* Icon */}
              <div className="text-jkd-gold mb-4 group-hover:scale-110 transition-transform duration-300">
                {product.icon}
              </div>

              {/* Title & Subtitle */}
              <div className="mb-4">
                <h3 className="text-xl font-bold text-white mb-1">{product.title}</h3>
                <p className="text-gray-500 text-sm">{product.subtitle}</p>
              </div>

              {/* Description */}
              <p className="text-gray-300 text-sm mb-4 leading-relaxed">{product.description}</p>

              {/* Features */}
              <ul className="space-y-2 mb-6">
                {product.features.map((feature, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm">
                    <span className="text-jkd-gold mt-0.5">✓</span>
                    <span className="text-gray-300">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <div className="w-full btn-outline group-hover:bg-jkd-gold group-hover:text-jkd-black group-hover:border-jkd-gold transition-all duration-300 flex items-center justify-center gap-2">
                {t('products.cta')}
                <ArrowRight className="w-4 h-4" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductCardsSection;
